import styled from 'styled-components'

import { Container as Card } from '../../../components/Card/styles'

export const Container = styled.article`
	min-height: 80vh;
`

export const Content = styled(Card)`
	display: flex;
	flex-direction: column;
	padding: 35px;
`